<app-messages-center-navigation-tree [treeModel]="systemQueuesTree.nodes"
                                     [selectedNode]="messagesCenterNavigationService.currentQueue">
</app-messages-center-navigation-tree>